import { IChoiceStep } from '../types';

import { ChoiceDisplayInstruction } from '../components/ChoiceDisplay';

import { VisualAcuityTest } from '../containers';

import { colors } from '../constants';

export const visualAcuityTestSteps: IChoiceStep[] = [
    {
        component: ChoiceDisplayInstruction,
        bgColor: colors.greenBg,
        props: {
            headerText: 'Bedek je <strong>linkeroog</strong> met je hand.',
        },
    },
    {
        component: VisualAcuityTest,
        bgColor: colors.white,
    },
    {
        component: ChoiceDisplayInstruction,
        bgColor: colors.greenBg,
        props: {
            headerText: 'Bedek je <strong>rechteroog</strong> met je hand.',
        },
    },
    {
        component: VisualAcuityTest,
        bgColor: colors.white,
    },
];
